/**
 * @generated SignedSource<<46383bf6fe73550e26f56d2e570929f2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DamSceneRole = "SCENE_ASSET_ROLE_CONFIG" | "SCENE_ASSET_ROLE_MATERIAL" | "SCENE_ASSET_ROLE_MODEL" | "SCENE_ASSET_ROLE_THUMBNAIL" | "SCENE_ASSET_ROLE_UNSPECIFIED";
export type useViewerThumbnailsBatchQuery$variables = {
  codes: ReadonlyArray<string>;
};
export type useViewerThumbnailsBatchQuery$data = {
  readonly damScenesByCodes: ReadonlyArray<{
    readonly assets: ReadonlyArray<{
      readonly asset: {
        readonly thumbnailUrl: string;
      };
      readonly roles: ReadonlyArray<DamSceneRole>;
    }>;
    readonly code: string | null;
  }>;
};
export type useViewerThumbnailsBatchQuery = {
  response: useViewerThumbnailsBatchQuery$data;
  variables: useViewerThumbnailsBatchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "codes"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "codes",
        "variableName": "codes"
      }
    ],
    "concreteType": "DamScene",
    "kind": "LinkedField",
    "name": "damScenesByCodes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DamScenesAssets",
        "kind": "LinkedField",
        "name": "assets",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DamSceneAsset",
            "kind": "LinkedField",
            "name": "asset",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnailUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useViewerThumbnailsBatchQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useViewerThumbnailsBatchQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7f82c8daed4799188a711167ede3a1e2",
    "id": null,
    "metadata": {},
    "name": "useViewerThumbnailsBatchQuery",
    "operationKind": "query",
    "text": "query useViewerThumbnailsBatchQuery(\n  $codes: [String!]!\n) {\n  damScenesByCodes(codes: $codes) {\n    code\n    assets {\n      roles\n      asset {\n        thumbnailUrl\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "226cd09bad1b1716d60c35dac2865498";

export default node;
